/**
 * Animation Constants
 * Predefined animation configs for consistent animations across the app
 */

export const ANIMATION_PRESETS = {
  // List animations with stagger
  LIST_STAGGER: {
    name: 'list-stagger',
    mode: 'out-in' as const,
    appear: true,
  },
  
  // Fast list stagger for small items (channels, tags)
  LIST_STAGGER_FAST: {
    name: 'list-stagger-fast',
    mode: 'out-in' as const,
    appear: true,
  },
  
  // Simple fade
  FADE: {
    name: 'fade',
    mode: 'out-in' as const,
    appear: true,
  },
  
  // Slide from bottom
  SLIDE_UP: {
    name: 'slide-up',
    mode: 'out-in' as const,
    appear: true,
  },
  
  // Slide from right
  SLIDE_LEFT: {
    name: 'slide-left',
    mode: 'out-in' as const,
    appear: true,
  },
  
  // Scale and fade (for modals)
  SCALE_FADE: {
    name: 'scale-fade',
    mode: 'out-in' as const,
    appear: true,
  },
} as const

/**
 * Animation timing constants
 */
export const ANIMATION_DURATION = {
  FAST: 200,
  NORMAL: 300,
  SLOW: 500,
} as const

/**
 * Stagger delays
 */
export const STAGGER_DELAY = {
  FAST: 20,    // For small items like channels
  NORMAL: 50,  // For medium items like cards
  SLOW: 100,   // For large items like posts
} as const

/**
 * Easing curves
 */
export const EASING = {
  SMOOTH: 'cubic-bezier(0.4, 0, 0.2, 1)',
  BOUNCE: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  LINEAR: 'linear',
} as const

